import {
  Autocomplete,
  FormControl,
  FormLabel,
  TextField,
  Typography,
} from "@mui/material";
import { tshirtSizes } from "Constants/data";
import React from "react";
import { useSelector } from "react-redux";

const TShirtSizeSelect = ({
  label = "T-Shirt Size",
  value,
  onBlur = () => {},
  onChange = () => {},
  error,
}) => {
  const { Common, Translation } = useSelector((state) => ({
    Common: state.Common.common,
    Translation: state.Translation.translation?.Common || {},
  }));

  const tshirtSizes = Common?.TShirt|| [];

  const selectedOption = React.useMemo(() => {
    return tshirtSizes.find((item) => item.ID === value) || null;
  }, [tshirtSizes, value]);

  return (
    <FormControl fullWidth>
      <FormLabel color="secondary" required label>
        {/* {label} */}
        {Translation?.TShirtSize}
      </FormLabel>
      <Autocomplete
        options={tshirtSizes}
        autoHighlight
        getOptionLabel={(option) => option.Value}
        clearIcon={false}
        value={selectedOption}
        onBlur={onBlur}
        onChange={(value, newVal) => onChange(newVal)}
        noOptionsText={<Typography>{Translation?.NoResultsFound}</Typography>}
        renderOption={(props, option) => {
          const { key, ...optionProps } = props;
          return (
            <Typography key={key} {...optionProps}>
              {option?.Value}
            </Typography>
          );
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            size="small"
            error={Boolean(error)}
            name="TShirtID"
            placeholder={Translation?.EnterYourTShirt}
            helperText={error}
            slotProps={{
              htmlInput: {
                ...params.inputProps,
                autoComplete: "new-password",
              },
            }}
          />
        )}
      />
    </FormControl>
  );
};

export default React.memo(TShirtSizeSelect);
